import { EventEmitter, Injectable } from "@angular/core";
import { Municipality } from "@app/project/model/municipality";
import { RootStoreState } from "@app/root-store";
import { ApiResultState, LoadingState } from "@app/root-store/api-result.state";
import { Action, select, Store } from "@ngrx/store";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { MunicipalityActions } from "../actions";
import { MunicipalitySelectors } from "../selectors";

@Injectable({
    providedIn: "root",
})
export class MunicipalityDispatchers {
    load(projectId: number): Observable<ApiResultState<Municipality>> {
        return this.store.pipe(
            select(MunicipalitySelectors.getActiveMunicipality),
            map(municipalitiesState => {
                if (municipalitiesState.callState === LoadingState.init) {
                    this.store.dispatch(MunicipalityActions.load({ projectId }));
                }
                return municipalitiesState;
            })
        );
    }

    upsert(municipality: Municipality, callbackEmitter: EventEmitter<Action>) {
        if (!municipality?.id) {
            this.store.dispatch(MunicipalityActions.create({ municipality, callbackEmitter }));
        } else {
            this.store.dispatch(MunicipalityActions.update({ municipality, callbackEmitter }));
        }
    }

    clear() {
        this.store.dispatch(MunicipalityActions.clear());
    }

    dispatch(action: Action) {
        this.store.dispatch(action);
    }

    constructor(private readonly store: Store<RootStoreState.State>) {}
}
